import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
// --- START OF FIX ---
// We no longer need useUser. We get everything from useAuth.
import { useAuth } from "../../../contexts/AuthContext";
// --- END OF FIX ---
import placeholderAvatar from "../../../assets/avatar-placeholder.png";
import "./UserProfile.css";

const UserProfile = ({ onLogout }) => {
  // --- START OF FIX ---
  // Get the currentUser object and loading state from useAuth().
  const { currentUser, loading: isLoading } = useAuth();
  const { email, fullName, profilePicture } = currentUser || {}; // Safely destructure from currentUser
  // --- END OF FIX ---

  const displayName = fullName || "User"; // Simplified display name logic
  const navigate = useNavigate();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const baseApiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";

  // This logic is fine, it correctly builds the full URL for the profile picture
  const actualPicSrc =
    profilePicture &&
    profilePicture.startsWith("/") &&
    !profilePicture.startsWith("//")
      ? `${baseApiUrl}${profilePicture}`
      : profilePicture;

  const avatarSrc = actualPicSrc || placeholderAvatar;

  const handleImageError = (e) => {
    // This fallback logic is good. No changes needed here.
    const erroredSrc = e.target.src;
    if (!e.target.onerror || erroredSrc === placeholderAvatar) {
      return;
    }
    e.target.onerror = null;
    e.target.src = placeholderAvatar;
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen((prev) => !prev);
  };

  const handleProfileNavigation = () => {
    navigate("/profile-setup");
    setIsDropdownOpen(false);
  };

  const handleLogoutClick = () => {
    if (onLogout) {
      onLogout();
    }
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="smai-user-profile" ref={dropdownRef}>
      <div className="smai-notification-bell">
        <div className="smai-notification-icon"></div>
      </div>
      <div className="smai-profile-container">
        <div className="smai-avatar">
          <img
            key={avatarSrc} // Use the final avatarSrc as the key to force re-renders on change
            src={avatarSrc}
            alt={displayName}
            onError={handleImageError}
          />
        </div>
        <div className="smai-user-info">
          <div className="smai-user-name">
            {isLoading ? "Loading..." : displayName}
          </div>
          <div className="smai-user-email">{isLoading ? "" : email}</div>
        </div>
        <div
          className="smai-dropdown-arrow"
          onClick={toggleDropdown}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && toggleDropdown(e)}
          aria-haspopup="true"
          aria-expanded={isDropdownOpen}
        ></div>
      </div>
      {isDropdownOpen && (
        <div className="smai-user-dropdown-menu">
          <button
            type="button"
            onClick={handleProfileNavigation}
            className="smai-dropdown-item"
          >
            Profile
          </button>
          <button
            type="button"
            onClick={handleLogoutClick}
            className="smai-dropdown-item"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
